<template>
    <div class="deliverySchedule__card pt-4 pb-6 lg:pt-0 lg:pb-2">
        <vue-flip width="100%" :bindWithMe="front" height="0">
            <delivery-card slot="front"
                :address="address"
                @skipped-fifth-delivery="showSkippingReasons"
                @holiday-button-clicked="flip"
                @has-recently-skipped-delivery="skip()"/>

            <delivery-card slot="back"
                :address="address"
                @skipped-fifth-delivery="showSkippingReasons"
                @holiday-button-clicked="flip"
                @has-recently-skipped-delivery="skip()"/>
        </vue-flip>

        <holiday-cancellation-modal v-if="showHolidayCancellationModal"/>

        <holiday-box-modal v-if="showHolidayBoxModal && !this.deferWeekEnabled"
            @holiday-button-clicked="flip"
            @has-recently-skipped-delivery="showModal = true"></holiday-box-modal>

        <delivery-skip-reason-modal v-if="showDeliverySkipReasonModal" :skipReasons="skipReasons" :skippedData="skippedData" @closed="closeModal()"/>
        <shift-delivery-frequency-modal v-if="showShiftDeliveryFrequencyModal || showShiftDeliveryWeekModal"
            :shiftWeek="showShiftDeliveryWeekModal"
            :shiftFrequency="showShiftDeliveryFrequencyModal"
            :selectedSkippingDate="selectedSkippingDate"
            @closed="showModal = false"
            @holiday-button-clicked="flip"
            @has-recently-skipped-delivery="showModal = true">
        </shift-delivery-frequency-modal>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import VueFlip from 'vue-flip';
import { isBefore, isSameDay } from 'date-fns';
import DeliveryCard from '@/components/partials/account/my-delivery-schedule/deliveryCard/DeliveryCard';
import HolidayCancellationModal from '@/components/modals/HolidayCancellationModal';
import ShiftDeliveryFrequencyModal from '@/components/modals/temporary-features/ShiftDeliveryFrequencyModal';
import HolidayBoxModal from '@/components/partials/account/gifting/HolidayBoxModal';
import DeliverySkipReasonModal from '@/components/modals/DeliverySkipReasonModal';
import {
    isSameDate,
} from '@/helpers/DateHelpers';

export default {
    name: 'DeliveryCardContainer',
    components: {
        HolidayCancellationModal,
        DeliveryCard,
        VueFlip,
        HolidayBoxModal,
        DeliverySkipReasonModal,
        ShiftDeliveryFrequencyModal,
    },
    data() {
        return {
            front: true,
            showModal: false,
            showDeliverySkipReasonModal: false,
            skippedData: null,
            holidaysBooked: 0,
        };
    },
    props: {
        address: {
            required: true,
            type: Object,
        },
    },
    methods: {
        flip() {
            this.front = !this.front;
        },
        closeModal() {
            this.showDeliverySkipReasonModal = false;
        },
        showSkippingReasons(skippedData) {
            this.skippedData = skippedData;
            this.$store.dispatch('account/fetchSkipDeliveryReasons');
            this.showDeliverySkipReasonModal = true;
        },
        skip() {
            if (this.selectedDelivery?.delivery_type === 'normal') {
                this.showModal = true;
            }

            this.holidaysBooked++;
        },
    },
    computed: {
        ...mapGetters({
            deliveries: 'scheduledOrder/getDeliveries',
            holidays: 'scheduledOrder/getHolidays',
            selectedDelivery: 'scheduledOrder/getSelectedDelivery',
            changePlanEnabled: 'account/getSkipConsecutiveHolidayEnabled',
            deferWeekEnabled: 'account/getShiftDeliveryScheduleEnabled',
            holidayGiftingEnabled: 'account/getHolidayGiftingEnabled',
        }),

        selectedDateTime() {
            return this.selectedDelivery.newDate || this.selectedDelivery.datetime;
        },

        earlierDeliveries() {
            const deliveryDate = this.selectedDelivery ? new Date(this.selectedDelivery.datetime) : false;
            return this.deliveries.filter((item) => {
                const date = new Date(item.datetime);
                const isValidDelivery = !item.is_locked && item.delivery_scheduled && item.delivery_type === 'normal';
                return isValidDelivery;
            });
        },

        featureFlagsEnabled() {
            return this.changePlanEnabled || this.deferWeekEnabled || this.holidayGiftingEnabled;
        },

        showShiftDeliveryFrequencyModal() {
            return this.showModal && this.changePlanEnabled && this.holidaysBooked === 4 && !this.deferWeekEnabled && !this.holidayGiftingEnabled;
        },

        selectedSkippingDate() {
            return new Date(this.selectedDelivery?.datetime);
        },

        showShiftDeliveryWeekModal() {
            return this.showModal && this.deferWeekEnabled;
        },

        showHolidayBoxModal: {
            get() {
                return this.$store.getters['gifting/getShowHolidayBoxModal'];
            },
            set(value) {
                this.$store.commit('gifting/setShowHolidayBoxModal', value);
            },
        },
        deliveryDays() {
            return this.$store.getters['scheduledOrder/getDeliveryDays'];
        },
        skipReasons() {
            return this.$store.getters['account/getSkipReaasons'];
        },
        holidays() {
            return this.$store.getters['scheduledOrder/getHolidays'];
        },
        optInDeliveryDays() {
            return this.$store.getters['scheduledOrder/getOptInDeliveryDays'];
        },
        showHolidayCancellationModal() {
            const holidaysScheduled = this.deliveries.filter(delivery => (delivery.delivery_scheduled === false) && (delivery.holiday_box_id !== ''));
            return this.showModal && !this.featureFlagsEnabled && holidaysScheduled.length >= 3 && !this.deferWeekEnabled;
        },
    },
    mounted() {
        const deliveries = this.deliveries.filter((item) => item.holiday_id);
        this.holidaysBooked = deliveries.length;
    },
};
</script>
